import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";
import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";

const DiagnosticLabIntegrationBlog = () => {
  return (
    <div className="min-h-screen w-full font-sans overflow-x-hidden bg-[#d2e5e4] text-black px-4 py-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Main Blog */}
        <div className="flex-1">
          <img
            src={image4}
            alt="AI Diagnostic and Lab Integration"
            className="w-full h-72 object-cover bg-gray-100 border border-gray-300 rounded-lg mb-6"
          />

          <div className="bg-sky-700 text-white text-3xl font-bold py-4 px-6 rounded mb-8">
            AI-Powered Diagnostic Report Generation & Lab Integration
          </div>

          <div className="space-y-8 text-lg text-black">
            <div>
              <h2 className="text-xl font-semibold mb-2">
                Key Challenges Solved
              </h2>
              <ul className="list-disc list-inside">
                <li>Delayed access to diagnostic results.</li>
                <li>Manual errors in report creation and entry.</li>
                <li>Lack of integration between labs and doctor systems.</li>
                <li>Limited insight for real-time clinical decisions.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                MedOps AI Diagnostic Integration
              </h2>
              <ul className="list-disc list-inside">
                <li>
                  <strong>AI-Driven Report Generation:</strong> Lab data is
                  auto-analyzed and structured using medical AI.
                </li>
                <li>
                  <strong>Real-Time Integration:</strong> Reports flow instantly
                  between labs, doctors, and patient dashboards.
                </li>
                <li>
                  <strong>Error Reduction:</strong> Automation eliminates data
                  entry errors and standardizes formatting.
                </li>
                <li>
                  <strong>Faster Turnaround:</strong> Reduced wait time from lab
                  processing to actionable diagnosis.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                Benefits for Doctors and Patients
              </h2>
              <ul className="list-disc list-inside">
                <li>
                  Immediate access to lab findings on the MedOps dashboard.
                </li>
                <li>Smarter diagnosis with AI-highlighted critical results.</li>
                <li>Improved treatment planning and continuity of care.</li>
                <li>Streamlined workflows for labs, reducing rework.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">Why It Matters</h2>
              <ul className="list-disc list-inside">
                <li>
                  Elevated patient care experience with quicker decisions.
                </li>
                <li>Reduced administrative overhead for medical staff.</li>
                <li>
                  Comprehensive digital record integration for compliance and
                  audits.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full md:w-1/3 border-t md:border-t-0 md:border-l border-gray-700 pt-10 md:pt-0 md:pl-8">
          <h3 className="text-xl font-semibold mb-6">Recent Blogs</h3>

          {[
            {
              to: "/inpatientoutpatientblog",
              alt: "InPatient and OutPatient Blog",
              title:
                "Explore how MedOps integrates with ABHA IDs, digital health missions, and AI automation to build the future of Indian healthcare",
              image: image2,
            },
            {
              image: image201,
              alt: "PredictiveAnalyticsBlog",
              to: "/predictiveanalyticsblog",
              title: " Learn more about Predictive Analytics ",
            },
            {
              to: "/inventorytrackingblog",
              alt: "Inventory Tracking Blog",
              title:
                "Real-Time Inventory Tracking with MedOps: Smarter Stock, Smarter Care",
              image: image6,
            },
            {
              to: "/hospitalpharmacyintegrationblog",
              alt: "Hospital Pharmacy Integration Blog",
              title:
                "Discover how AI-powered hospital management systems like MedOps reduce paperwork, improve staff efficiency, and enable data-driven decisions",
              image: image5,
            },
            {
              image: image203,
              alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
              to: "/cuttingdownpatientreportdeliverytimewithaiblog",
              title:
                "Learn more about Cutting Down Patient Report Delivery Time with AI",
            },

            {
              to: "/advancedanalyticscampaignblog",
              alt: "Advanced Analytics Blog",
              title: "Advanced Analytics & Campaign Management",
              image: image3,
            },
            {
              to: "/voiceprescriptionblog",
              alt: "Voice Prescription Blog",
              title:
                "Learn how MedOps uses AI for real-time monitoring, cloud-based records, and decision support to enhance patient care",
              image: image1,
            },
            {
              image: image202,
              alt: "BestHMSforYourHospitalBlog",
              to: "/besthmsforyourhospitalblog",
              title: "Learn more about Best HMS for Your Hospital ",
            },
                 {
                                      image: image204,
                                      alt: "MedicineForecastingBlog",
                                      to: "/medicineforecastingblog",
                                      title: " Learn more about Medicine Forecasting ",
                                    },
          ].map((blog, idx) => (
            <div key={idx} className="mb-6">
              <Link
                to={blog.to}
                className="flex flex-col gap-2 hover:opacity-90"
              >
                <img
                  src={blog.image}
                  alt={blog.alt}
                  className="w-full h-54 object-cover bg-gray-100 border border-gray-300 rounded"
                />
                <span className="text-sky-600 font-semibold text-sm">
                  {blog.title}
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DiagnosticLabIntegrationBlog;
